import { Injectable, CanActivate, ExecutionContext, UnauthorizedException } from '@nestjs/common';
import { Response } from 'express';
import { Reflector } from '@nestjs/core';
import { NEED_LOGIN_KEY } from '../const';

/**
 * AuthNPaas 守卫
 * 负责协调所有鉴权检查，具体检查逻辑委托给 PermissionService
 */
@Injectable()
export class AuthNPaasGuard implements CanActivate {
  constructor(private reflector: Reflector) {}

  async canActivate(context: ExecutionContext): Promise<boolean> {
    const http = context.switchToHttp();
    const request = http.getRequest();
    const response = http.getResponse<Response>();

    const { userId, loginUrl } = request.userContext || {};

    // 读取 NeedLogin 元数据并标记到请求对象，供异常过滤器使用
    const needLoginMeta = this.reflector.getAllAndOverride<{
      loginPath?: string;
    }>(NEED_LOGIN_KEY, [context.getHandler(), context.getClass()]);

    // NeedLogin 且无 userId -> 一律 401；拿得到 loginUrl 时顺带透出跳转 url
    if (needLoginMeta && !userId) {
      if (loginUrl) {
        response.setHeader('x-login-url', loginUrl);
      }
      throw new UnauthorizedException('未登录');
    }

    return true;
  }
}
